import { render } from "./CurrentBorrow.vue?vue&type=template&id=feeb13b4"
import script from "./CurrentBorrow.vue?vue&type=script&lang=js"
export * from "./CurrentBorrow.vue?vue&type=script&lang=js"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__